import React, { useState } from 'react'
import { Menu, MenuItem, MenuList, Paper } from '@mui/material'
import { MoreButton } from 'common/Button/MoreButton'
import TextColorFontBody from 'common/Typography/TextColorFontBody'
import circlesOrbitColorPalette from 'common/ui/circlesColorTheme'
import { CampaignPromocodeDetails } from 'types/api/faber/reward.type'

import CampaignUpdateDialog from './CampaignUpdateDialog'
import PromocodeUsersDialog from './PromocodeUsersDialog'

interface Props {
  row: CampaignPromocodeDetails
  promocode: string
  openDialog: boolean
  handleCloseDialog: () => void
  handleViewUsersClick: (promocode: string) => void
}

const CampaignActionMenu = ({
  row,
  promocode,
  openDialog,
  handleCloseDialog,
  handleViewUsersClick
}: Props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const [updateDialogOpen, setUpdateDialogOpen] = useState(false)

  const handleUpdateDialogOpen = () => {
    setUpdateDialogOpen(true)
  }

  const handleDialogClose = () => {
    setUpdateDialogOpen(false)
  }

  return (
    <>
      <MoreButton onClick={handleMenuOpen} />
      <Paper>
        <MenuList dense>
          <Menu
            id='action-menu'
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button'
            }}
          >
            <MenuItem onClick={() => handleUpdateDialogOpen()}>
              <TextColorFontBody
                sx={{
                  color: circlesOrbitColorPalette.neutrals[600],
                  fontSize: '12px'
                }}
              >
                Update
              </TextColorFontBody>
            </MenuItem>
            <MenuItem onClick={() => handleViewUsersClick(row.campaignCode)}>
              <TextColorFontBody
                sx={{
                  color: circlesOrbitColorPalette.neutrals[600],
                  fontSize: '12px'
                }}
              >
                View consumers
              </TextColorFontBody>
            </MenuItem>

            {promocode && (
              <PromocodeUsersDialog
                promocode={promocode}
                openDialog={openDialog}
                handleCloseDialog={handleCloseDialog}
              />
            )}
            <CampaignUpdateDialog
              campaignRow={row}
              handleDialogClose={handleDialogClose}
              openDialog={updateDialogOpen}
              handleMenuClose={handleMenuClose}
            />
          </Menu>
        </MenuList>
      </Paper>
    </>
  )
}

export default CampaignActionMenu
